import React from 'react';

export default function TextInput(props) {
  const value = props.value || '';
  return (
    <input {...props} value={value} />
  )
}

TextInput.defaultProps = {
  value: '',
  type: 'text',
}



// WEBPACK FOOTER //
// ./src/elements/TextInput.js